export default {
  free: 'GRATIS',
  save: 'Bespaar {{amount}}',
};
